import { all } from 'redux-saga/effects';

import { watchAnalyticsSaga } from 'AnalyticsPackage/MainModule/sagas/analyticsSaga';
import { watchAccountSaga } from 'CorePackage/AccountModule/sagas/accountSaga';
import { watchCatalogSaga } from 'CorePackage/CatalogsModule/sagas/catalogsSaga';
import { watchDictionariesSaga } from 'CorePackage/DictionariesModule/sagas/dictionariesSaga';
import { watchRegistrySaga } from 'CorePackage/RegistryModule/sagas/registrySaga';
import { watchKnmSaga } from 'KnmPackage/MainModule/sagas/knmSaga';
import { watchPlanListSaga } from 'PlanListPackage/MainModule/sagas/planListSaga';
import { watchPlanListFilterSaga } from 'PlanListPackage/PlanListPanelModule/sagas/planListFilterSaga';
import { watchPlanSaga } from 'PlanPackage/MainModule/sagas/planSaga';
import { watchKnmListByPlanSaga } from 'KnmListByPlanPackage/MainModule/sagas/knmListByPlanSaga';
import { watchSmevMonitoringSaga } from 'SmevMonitoringPackage/MainModule/sagas/smevMonitoringSaga';
import { watchExportSaga } from 'ExportPackage/MainModule/sagas/exportSaga';
import { watchKnmListSaga } from 'KnmListPackage/MainModule/sagas/knmListSaga';
import { watchKnmListFilterSaga } from 'KnmListPackage/KnmListFiltersModule/sagas/knmListFilterSaga';
import { watchPmListFilterSaga } from 'PreventionPackage/PmListFiltersModule/sagas/pmListFilterSaga';
import { watchKnmSearchSaga } from 'KnmSearchPackage/MainModule/sagas/knmSearchSaga';
import { watchUserRequirementsSaga } from 'PersonalAccountPackage/UserRequirementsModule/sagas/userRequirementsSaga';
import { watchUserInfoSaga } from 'PersonalAccountPackage/UserInfoModule/sagas/userInfoSaga';
import { watchCheckListsSaga } from 'PersonalAccountPackage/CheckListModule/sagas/checkListsSaga';
import { watchAdminSaga } from 'PersonalAccountPackage/AdminModule/sagas/adminSaga';
import { watchPersonalAccountSaga } from 'PersonalAccountPackage/MainModule/sagas/personalAccountSaga';
import { watchNewsSaga } from 'NewsPackage/MainModule/sagas/newsSaga';
import { watchNewsFormSaga } from 'NewsPackage/FormModule/sagas/newsFormSaga';
import { watchImportSaga } from 'ImportPackage/MainModule/sagas/importSaga';
import { watchErknmAnalyticsSaga } from 'AnalyticsPackage/ErknmAnalyticsModule/sagas/erknmAnalyticsSaga';
import { watchSimilaritiesSaga } from 'SimilaritiesPackage/MainModule/sagas/similaritiesSaga';
import { watchAuthSaga } from 'AuthPackage/MainModule/sagas/authSaga';
import { watchKnmRegistrySaga } from 'RegistryPackage/MainModule/sagas/knmRegistrySaga';
import { watchKnmPreviewSaga } from 'KnmPreviewPackage/MainModule/sagas/knmPreviewSaga';
import { watchPreventionSaga } from 'PreventionPackage/MainModule/sagas/preventionSaga';
import { watchKnmHeaderSaga } from 'KnmPackage/KnmHeaderModule/saga/KnmHeaderSaga';
import { watchKnmErknmSaga } from 'KnmErknmPackage/MainModule/sagas/knmErknmSaga';
import { watchKnmPmSaga } from 'KnmPmPackage/MainModule/sagas/knmPmSaga';
import { watchKnmErpSaga } from 'KnmErpPackage/MainModule/sagas/knmErpSaga';
import { watchFeedbackSaga } from 'FeedbackPackage/MainModule/sagas/feedbackSaga';
import { watchKnmDocumentsSaga } from 'KnmPackage/KnmDocumentsModule/sagas/knmDocumentsSaga';
import { watchReportsSaga } from 'ReportsPackage/MainModule/sagas/reportsSaga';
import { watchRequirementsNpaSaga } from 'KnmPackage/RequirementsNpaModalModule/sagas/requirementsNpaSaga';
import { watchDecisionListSaga } from 'DecisionListPackage/MainModule/sagas/decisionListSaga';
import { watchDecisionSaga } from 'DecisionPackage/MainModule/sagas/decisionSaga';
import { watchPublishRulesSaga } from 'PublishRulesPackage/MainModule/sagas/publishRulesSaga';
import { watchUserNotificationSaga } from 'UserNotificationPackage/MainModule/sagas/UserNotificationSaga';
import { erknmAnalyticsProsecutorOrganizationSaga } from 'AnalyticsPackage/ErknmAnalyticsProsecutorOrganizationModule/sagas/erknmAnalyticsProsecutorOrganizationSaga';
import { watchAgreementListSaga } from 'AgreementListPackage/MainModule/sagas/agreementListSaga';
import { watchAgreementListFilterSaga } from 'AgreementListPackage/AgreementListFiltersModule/sagas/agreementListFilterSaga';
import { watchDecisionListFilterSaga } from 'DecisionListPackage/DecisionListFiltersModule/sagas/decisionListFilterSaga';

import { watchChangeKnoInPlanSaga } from '../../../ChangeKnoInPlanPackage/sagas/changeKnoInPlanSaga';
import { watchCoreSaga } from './coreSaga';
import { watchPassportGroupSaga } from '../../../PassportGroupPackage/MainModule/sagas/passportGroupSaga';
import { watchChangeKnoInMeasureSaga } from '../../../ChangeKnoInMeasurePackage/sagas/changeKnoInMeasureSaga';
import { watchSmevRequestSaga } from '../../../SmevMessagesPackage/MainModule/sagas/SmevRequestSaga';

export function* rootSaga() {
  yield all([
    watchAuthSaga(),
    watchAccountSaga(),
    watchCoreSaga(),
    watchAnalyticsSaga(),
    watchCatalogSaga(),
    watchDictionariesSaga(),
    watchRegistrySaga(),
    watchKnmSaga(),
    watchKnmErknmSaga(),
    watchKnmPmSaga(),
    watchKnmErpSaga(),
    watchPlanListSaga(),
    watchPlanListFilterSaga(),
    watchPlanSaga(),
    watchKnmListByPlanSaga(),
    watchDecisionListSaga(),
    watchSmevMonitoringSaga(),
    watchExportSaga(),
    watchKnmListSaga(),
    watchKnmListFilterSaga(),
    watchPmListFilterSaga(),
    watchDecisionListFilterSaga(),
    watchKnmSearchSaga(),
    watchUserRequirementsSaga(),
    watchUserInfoSaga(),
    watchCheckListsSaga(),
    watchAdminSaga(),
    watchPersonalAccountSaga(),
    watchNewsSaga(),
    watchNewsFormSaga(),
    watchImportSaga(),
    watchErknmAnalyticsSaga(),
    erknmAnalyticsProsecutorOrganizationSaga(),
    watchSimilaritiesSaga(),
    watchKnmRegistrySaga(),
    watchKnmPreviewSaga(),
    watchPreventionSaga(),
    watchKnmHeaderSaga(),
    watchFeedbackSaga(),
    watchKnmDocumentsSaga(),
    watchReportsSaga(),
    watchRequirementsNpaSaga(),
    watchDecisionSaga(),
    watchChangeKnoInPlanSaga(),
    watchChangeKnoInMeasureSaga(),
    watchPublishRulesSaga(),
    watchUserNotificationSaga(),
    watchPassportGroupSaga(),
    watchAgreementListSaga(),
    watchAgreementListFilterSaga(),
    watchSmevRequestSaga(),
  ]);
}
